import React, {useContext, useEffect, useState} from 'react';
import {Form, Input, Select} from 'antd';
import GenericDialog from '@common/GenericDialog';
import axios from '@common/axios';
import {UserContext} from '@context/UserContext';

const CreateScheduleDialog = ({visible, handleClose, onSuccess}) => {
    const {user} = useContext(UserContext);
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        if (!visible) {
            form.resetFields();
            setErrorMessage(null);
        }
    }, [visible, form]);

    const handleSubmit = async () => {
        let values;
        try {
            values = await form.validateFields();
        } catch {
            return;
        }

        setIsLoading(true);
        setErrorMessage(null);
        try {
            const response = await axios.post('/web/ui/lessonScheduler/plans', {
                name: values.name,
                description: values.description || null,
                year: values.year || null,
                classIds: values.classIds?.length ? values.classIds : null,
            });
            onSuccess(response.data);
            handleClose();
        } catch (e) {
            const msg = e?.response?.data?.message || 'Failed to create schedule.';
            setErrorMessage(msg);
        } finally {
            setIsLoading(false);
        }
    };

    const currentYear = new Date().getFullYear();
    const startYear = Math.min(currentYear, 2026);
    const yearOptions = Array.from({ length: currentYear + 5 - startYear + 1 }, (_, i) => ({
        label: startYear + i,
        value: startYear + i,
    }));

    const classOptions = (user?.classes || []).map(c => ({
        label: c.className,
        value: c.classId,
    }));

    return (
        <GenericDialog
            title="New Schedule"
            open={visible}
            onClose={handleClose}
            isLoading={isLoading}
            errorMessage={errorMessage}
            dialogWidth={480}
            buttons={[
                {name: 'Cancel', extraProps: {type: 'text'}},
                {name: 'Create', callback: handleSubmit, extraProps: {type: 'primary'}},
            ]}
        >
            <Form form={form} layout="vertical" className="ch-form">
                <Form.Item name="name" label="Name" rules={[{required: true, message: 'Name is required'}]}>
                    <Input placeholder="e.g. Year 10 Term 1" />
                </Form.Item>
                <Form.Item name="description" label="Description">
                    <Input.TextArea rows={3} placeholder="Optional description" />
                </Form.Item>
                <Form.Item name="year" label="Year">
                    <Select options={yearOptions} placeholder="Select a year (optional)" allowClear />
                </Form.Item>
                <Form.Item name="classIds" label="Classes">
                    <Select options={classOptions} placeholder="Select classes (optional)" allowClear mode="multiple" />
                </Form.Item>
            </Form>
        </GenericDialog>
    );
};

export default CreateScheduleDialog;
